import React from "react";
import CustomSelect from "../common/Select";

const opcionesTipoSangre = [
  { value: "a+", label: "A+" },
  { value: "a-", label: "A-" },
  { value: "b+", label: "B+" },
  { value: "b-", label: "B-" },
  { value: "ab+", label: "AB+" },
  { value: "ab-", label: "AB-" },
  { value: "o+", label: "O+" },
  { value: "o-", label: "O-" }
];

function SelectorTipoSangre({ value, onChange, error, required = false }) {
  return (
    <CustomSelect
      options={opcionesTipoSangre}
      value={value}
      onChange={onChange}
      placeholder=""
      label="Tipo de sangre"
      error={error}
      required={required}
    />
  );
}

export default SelectorTipoSangre;